export const LIVE_DVR_MIN_SEGMENTS = 3;

export const getLiveDvrSegmentCount = sensor =>
  Number(sensor?.recorderInfo?.info?.totalSegments ?? 0);

export const isLiveDvrReady = sensor =>
  Boolean(sensor?.live) && getLiveDvrSegmentCount(sensor) >= LIVE_DVR_MIN_SEGMENTS;

export const getSafeLiveMode = (mode, sensor) =>
  mode === 'highQualityDvr' && !isLiveDvrReady(sensor) ? 'highQuality' : mode;

export const getLiveDvrWarmupMessage = () =>
  `DVR is not available yet. Wait until the recorder accumulates about ${LIVE_DVR_MIN_SEGMENTS} segments, then try again.`;

export const mapLiveDvrError = error => {
  const message = typeof error === 'string' ? error : error?.message || 'Unknown error';

  if (message === 'Recorder not running. Cannot use DVR.') {
    return getLiveDvrWarmupMessage();
  }

  return message;
};
